import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface MainKPIDetailsPanelSkeletonProps {
  onClose: () => void;
}

const MainKPIDetailsPanelSkeleton: React.FC<MainKPIDetailsPanelSkeletonProps> = ({
  onClose,
}) => {
  return (
    <div 
      id="main-kpi-details-panel"
      className="mt-4 p-6 bg-white rounded-lg border border-gray-300 shadow-sm"
    >
      {/* Header with close button */}
      <div className="flex justify-between items-start mb-6">
        <div className="flex-1">
          {/* Title skeleton */}
          <Skeleton height={28} width={200} className="mb-4" />

          {/* Main KPI Information skeleton */}
          <div className="space-y-3">
            {/* First row skeleton */}
            <div className="flex items-center space-x-6">
              <Skeleton height={20} width={80} />
              <Skeleton height={20} width={100} />
              <Skeleton height={20} width={120} />
            </div>

            {/* Second row skeleton */}
            <div className="flex items-center space-x-6">
              <Skeleton height={20} width={70} />
              <Skeleton height={20} width={140} />
            </div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors ml-4"
          aria-label="Chiudi dettagli"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Two Column Layout: 30% - 70% */}
      <div className="grid grid-cols-10 gap-6">
        {/* Left Column (30%) - Completion Progress Bar Skeleton */}
        <div className="col-span-3">
          {/* Title skeleton */}
          <Skeleton height={24} width={160} className="mb-4" />
          
          {/* Progress bar skeleton */}
          <div className="relative w-full mb-3">
            <Skeleton height={40} width="100%" />
          </div>
          
          {/* Additional info skeleton */}
          <Skeleton height={16} width={120} />
        </div>

        {/* Right Column (70%) - Specific KPIs Skeleton */}
        <div className="col-span-7">
          {/* Title skeleton */}
          <Skeleton height={24} width={110} className="mb-4" />
          
          {/* Grid for KPI gauges skeleton - 2 per row (only one row) */}
          <div className="grid grid-cols-2 gap-6">
            {/* Skeleton gauge charts - only 2 items */}
            {[1, 2].map((index) => (
              <div key={index} className="flex flex-col items-center">
                {/* Circular skeleton for gauge */}
                <Skeleton circle height={80} width={80} className="mb-2" />
                {/* Name skeleton */}
                <Skeleton height={14} width={70} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainKPIDetailsPanelSkeleton;
